// Заголовок страницы в шапке оболочки.
//
// Оболочка держит в шапке место под заголовок (`TitleSlot`); экран кладёт туда
// свой `h1` с «?» и, если нужно, пилюлю рядом. Так заголовок, свежесть данных и
// профиль стоят одной строкой, а полотно под шапкой целиком отдано делу.
//
// ⚠ Места нет (экран отрисован без оболочки — тест, витрина) — заголовок стоит
// в самом экране, первой строкой. Заголовок не пропадает ни в одном случае.

import { createContext, useContext, type ReactNode, type Ref } from "react";
import { createPortal } from "react-dom";

import { HintButton, type HintMore } from "@/money/Hint";
import type { Hint } from "@/money/types";

export const TitleSlot = createContext<HTMLElement | null>(null);

export function PageHeader({
  title,
  hint,
  hintMore,
  aside,
  headingRef,
}: {
  readonly title: string;
  readonly hint?: Hint;
  /** Блоки подсказки по ситуации; золотой знак — только если заголовок и есть главный вопрос экрана. */
  readonly hintMore?: HintMore | undefined;
  /** Справа от заголовка: пилюля состояния страницы. */
  readonly aside?: ReactNode;
  /** Цель переноса фокуса при смене состояния экрана (вход → профиль). */
  readonly headingRef?: Ref<HTMLHeadingElement>;
}) {
  const slot = useContext(TitleSlot);
  const heading = (
    <div className="flex min-w-0 items-center gap-sm">
      <h1
        ref={headingRef}
        tabIndex={headingRef === undefined ? undefined : -1}
        title={title}
        className="line-clamp-2 text-xl font-semibold tracking-tight text-ink sm:truncate"
      >
        {title}
      </h1>
      {hint === undefined ? null : <HintButton about={title} hint={hint} more={hintMore} />}
      {aside}
    </div>
  );
  return slot === null ? heading : createPortal(heading, slot);
}
